import { render, staticRenderFns } from "./Liquidacion_Agregar.vue?vue&type=template&id=fb1d544c&scoped=true"
import script from "./Liquidacion_Agregar.vue?vue&type=script&lang=js"
export * from "./Liquidacion_Agregar.vue?vue&type=script&lang=js"
import style0 from "./Liquidacion_Agregar.vue?vue&type=style&index=0&id=fb1d544c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb1d544c",
  null
  
)

export default component.exports